import API from "@utilities/api";
import moduleInit from "@utilities/module-init";
import Events from "@utilities/events";

const SAMPLE_MODAL_CONTENT_HOOK = '[js-hook-modal-template-wrapper]';
const PRODUCT_SAMPLE_SIDEBAR_TOGGLE_BUTTON_HOOK = '[js-hook-product-sample-sidebar-toggle-button]';
const PRODUCT_SAMPLE_START_PACK = '[js-hook-sample-products-start-pack]';
const PRODUCT_SAMPLE_FORM = '[js-hook-product-sample-form]';
const PRODUCT_SAMPLE_ACTION = '[js-hook-sample-action]';
const PRODUCT_SAMPLE_IMG = '[js-hook-sample-product-img]';
const PRODUCT_SAMPLE_COLLECTION = '[js-hook-sample-collection]';
const HIDDEN_CLASS = 'u-hidden';

/**
 * Used to open samples modal and replace html with ajax response
 *
 * @class ProductSampleModalToggle
 */
class ProductSampleModalToggle {
  constructor(element) {
    this.element = element;
    this.productSampleEndpoint = this.element.dataset.productSampleUrl;
    this.productSampleModalId = this.element.dataset.modalId;
    this.productSamplesModal = document.getElementById(this.productSampleModalId);
    this.productSamplesModalContent = this.productSamplesModal.querySelector(SAMPLE_MODAL_CONTENT_HOOK);
    this.swatchDetailModals = [...document.querySelectorAll('.modal--swatch-detail')];

    this._bindEvents();
  }

  _bindEvents() {
    this.element.addEventListener('click', (e) => this.openProductSampleModal(e))
  }

  openProductSampleModal (e) {
    e.preventDefault();

    API.get(this.productSampleEndpoint)
      .then((response) => this.updateSampleModalContent(response.data))
      .catch((error) => {
        console.log('Product sample modal data fetch error.', error); // eslint-disable-line no-console
      });
  }

  toggleSidebar (e) {
    e.preventDefault();

    this.sampleStartPack.classList.add(HIDDEN_CLASS);
    this.sampleForm.classList.remove(HIDDEN_CLASS);
    this.sampleAction.classList.remove(HIDDEN_CLASS);
    this.sampleImg.classList.remove('sample-products__product-images--image-min');
    this.sampleCollection.classList.remove('sample-products__modal-collection--min')
  }

  updateSampleModalContent (data) {
    this.productSamplesModalContent.innerHTML = data;

    this.initModules();

    Events.$trigger('lazyimage::update');

    Events.$trigger(`modal[${this.productSampleModalId}]::open`);
    Events.$trigger('modal::bind-buttons', { data: { id: this.productSampleModalId } });
  }

  sidebarInit () {
    this.productSampleSidebarToggleButton = document.querySelector(PRODUCT_SAMPLE_SIDEBAR_TOGGLE_BUTTON_HOOK);
    this.sampleStartPack = document.querySelector(PRODUCT_SAMPLE_START_PACK);
    this.sampleForm = document.querySelector(PRODUCT_SAMPLE_FORM);
    this.sampleAction = document.querySelector(PRODUCT_SAMPLE_ACTION);
    this.sampleImg = document.querySelector(PRODUCT_SAMPLE_IMG);
    this.sampleCollection = document.querySelector(PRODUCT_SAMPLE_COLLECTION);

    this.productSampleSidebarToggleButton.addEventListener('click', (e) => this.toggleSidebar(e));
  }

  initModules() {
    moduleInit.async('[js-hook-product-sample-form]', () =>
      import(/* webpackChunkName: "js/legacy/ProductSampleForm" */ '@components/product-sample-form'),
    );

    this.sidebarInit();

    this.swatchDetailModals.forEach(modal => {
      const modalId = modal.id;

      Events.$trigger('modal::bind-buttons', { data: { id: modalId } });
    })
  }

}

export default ProductSampleModalToggle;
